import { Injectable } from '@angular/core';
import { RefusedError } from '../../core/services/core.refused-error';
import * as _ from 'lodash';
import { PermissionsService } from '../../core/services/core.permissions.service';
import { ScmService } from './services/scm.service';
import { ScmLinkService } from './services/scm.link.service';
import { TourService } from '../../core/modules/tour/tour.service';
import { StateService } from '@uirouter/angular';

@Injectable()
export class ScmResolvesService {

    constructor(
        private permissionsService: PermissionsService,
        private scmService: ScmService,
        private scmLinkService: ScmLinkService,
        private tourService: TourService,
        private stateService: StateService
    ) {
    }

    async security(project: any): Promise<any> {
        const scm = project.rel.permissions.scmgit || project.rel.permissions.scmsvn;
        if (this.permissionsService.read('scm', scm)) {
            return true;
        }
        else {
            // The shape every refused resolve rejects with; the ui-router error hook
            // reads the status off it and redirects. See docs/PERMISSION-REDIRECT.md.
            throw RefusedError.forbidden('User cannot read this project SCM');
        }
    }

    getScm(project: any) {
        return this.scmService.fetch(project.unixName, 'scm');
    }

    getInfoBreadcrumbs(project: any) {
        return this.scmLinkService.crumbsFor.info(project);
    }

    getHomeTour($transition$: any, scm: any) {
        if ($transition$.to().name == 'home.project.summary.scm') {
            return this.tourService.setTour('scmHomeCtrl');
        }
    }

    scmCheck(unixName: string, scm: any) {
        if (_.get(scm, 'options.isEmpty', false)) {
            this.stateService.go('home.project.summary.scm', { unixName: unixName });
            return false;
        }
        return true;
    }

    getBrowseBreadcrumbs(stateParams: any, project: any, scm: any) {
        return this.scmLinkService.crumbsFor.browse(stateParams, project);
    }

    getBrowseTour() {
        return this.tourService.setTour('scmBrowseCtrl');
    }

    getCommitsBreadcrumbs(stateParams: any, project: any, scm: any) {
        if (_.get(scm, 'scmType', '') == 'cvs') {
            return this.scmLinkService.crumbsFor.browse(stateParams, project);
        }
        return this.scmLinkService.crumbsFor.commits(stateParams, project);
    }

    getCommitBreadcrumbs(stateParams: any, project: any, scm: any) {
        return this.scmLinkService.crumbsFor.commit(stateParams, project);
    }

    getMergeBreadcrumbs(stateParams: any, project: any, scm: any) {
        return this.scmLinkService.crumbsFor.merge(stateParams, project, scm);
    }
}
